import { NotificationType } from 'angular2-notifications';

export class ToastMessage {
  constructor(
    public title: string = "", 
    public subtitle: string = "", 
    public type: NotificationType = NotificationType.Info
    ) { }
  }